import React from 'react';
import { filterDataProps } from '@THC/utils/helpers';
import styles from './VisuallyHidden.module.scss';
export const VisuallyHidden = ({ children, id, ...rest }) => (<span className={styles.visuallyHidden} id={id} {...filterDataProps(rest)}>
		{children}
	</span>);
